import { Component } from '@angular/core';
import { BaseModalComponent } from '../base-modal.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-sponsor-modal',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './sponsor-modal.component.html',
  styleUrl: './sponsor-modal.component.scss'
})
export class SponsorModalComponent extends BaseModalComponent {}
